import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexInputs',
  setup(__props) {

const BasicForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/BasicForm.vue"))
const FloatingForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/FloatingForm.vue"))
const SelectSizing = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/SelectSizing.vue"))
const FileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/FileInput.vue"))
const FlatInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/FlatInput.vue"))
const HtmlInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/HtmlInput.vue"))
const FloatingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/FloatingInput.vue"))
const EdgesInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/EdgesInput.vue"))
const RaiseInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/RaiseInput.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicForm)),
      _createVNode(_unref(FloatingForm)),
      _createVNode(_unref(SelectSizing)),
      _createVNode(_unref(FileInput)),
      _createVNode(_unref(FlatInput)),
      _createVNode(_unref(HtmlInput)),
      _createVNode(_unref(FloatingInput)),
      _createVNode(_unref(EdgesInput)),
      _createVNode(_unref(RaiseInput))
    ])
  ]))
}
}

})